import React from 'react';
import './TechBanner.css';

const TechBanner = ({ darkMode }) => {
  const technologies = [
    { name: 'Microsoft Dynamics 365', category: 'ERP' },
    { name: 'Velneo', category: 'ERP' },
    { name: 'Odoo', category: 'ERP' },
    { name: 'Vulpin 360', category: 'ERP propio' },
    { name: 'React', category: 'Desarrollo' },
    { name: 'Node.js', category: 'Desarrollo' },
    { name: 'TypeScript', category: 'Desarrollo' },
    { name: 'Make', category: 'Automatización' },
    { name: 'n8n', category: 'Automatización' },
    { name: 'Power BI', category: 'Analytics' },
    { name: 'AWS', category: 'Cloud' },
    { name: 'Docker', category: 'Cloud' },
    { name: 'MySQL', category: 'Datos' },
    { name: 'PostgreSQL', category: 'Datos' },
    { name: 'WordPress', category: 'Web' },
    { name: 'Laravel', category: 'Web' },
    { name: 'HubSpot CRM', category: 'CRM' },
  ];

  return (
    <section className={`tech-banner ${darkMode ? 'dark' : ''}`}>
      <div className="tech-banner-content">
        <div className="tech-banner-header">
          <h2 className="tech-banner-title">Herramientas con las que integramos y automatizamos</h2>
          <p className="tech-banner-subtitle">
            No tienes que encajar tú con un fabricante rígido: elegimos stack
            según el problema (ERP existente, Vulpin 360, APIs, datos y
            automatización).
          </p>
        </div>

        <div className="tech-grid">
          {technologies.map((tech, index) => (
            <div key={index} className="tech-badge">
              <span className="tech-badge-name">{tech.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechBanner;
